module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Regular.7c3141b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nca/css/font/NotoSansKR-Regular.woff
// module id = O9/B
// module chunks = 0